import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curr_tab: 0,
    };
    this.processHref();
  }

  changeTab = tab_id => {
    this.setState({ curr_tab: tab_id });
  };

  processHref() {
    let link = window.location.href.toString();
    if (link.includes("/#/admin")) {
      this.changeTab(4);
    } else if (link.includes("/#/agency")) {
      this.changeTab(1);
    } else if (link.includes("/#/legis")) {
      this.changeTab(2);
    } else if (link.includes("/#/org")) {
      this.changeTab(3);
    } else if (link.includes("/#/profile")) {
      this.changeTab(5);
    } else {
      this.changeTab(0);
    }
  }

  componentDidMount() {
    this.processHref();
  }

  componentWillReceiveProps(nextProps){
    this.processHref();
  }

  renderContent() {
    switch (localStorage.getItem("role")) {
      case null:
        return (
          <li className="nav-item active" key="1">
            <Link className="nav-link" to="/login">
              {" "}
              Login
            </Link>
          </li>
        );
      default:
        let handleLogout = function(e) {
          e.preventDefault();
          localStorage.clear();
          cookies.remove('token', { path: '/' });
          window.location.reload();
        };
        let name = localStorage.getItem("name");
        if (!localStorage.getItem("role")) {
          handleLogout();
        }

        return (
          <div
            className="dropdown show ml-2"
            style={{ marginRight: 80, minWidth: 60 }}
          >
            <a
              className="btn btn-secondary dropdown-toggle btn-warning active"
              href="#!"
              role="button"
              style={{ filter: "contrast(300%)" }}
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {name}
            </a>

            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <Link className=" dropdown-item" to="/profile" onClick={() => this.changeTab(5)}>
                Profile
              </Link>
              <Link className=" dropdown-item" to="!#" onClick={handleLogout}>
                Logout
              </Link>
            </div>
          </div>
        );
    }
  }
  changeColor(id) {
    document.getElementById(id).setAttribute("color", "yellow");
  }
  render() {
    const isAdmin =
      localStorage.getItem("role") &&
      JSON.parse(localStorage.getItem("role")).some(
        r => r.name === "ROLE_ADMIN"
      );
    // console.log(this.props);
    return (
      <nav className="navbar navbar-expand-lg navbar-dark header">
        <img
          className="img-fluid mx-2"
          alt="logo"
          width="80px"
          height="80px"
          src="http://www.transportationprojects.org/img/website-logo.png"
        />
        <a className="navbar-brand mt-2" id="title" href="/">
          <i>US Major Transportation Projects</i>
          <br />
          <p id="sub">
            <strong style={{ color: "yellow", fontSize: "20pt" }}>
              Data Management System
            </strong>
          </p>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <strong className="navbar-toggler-icon" />
        </button>
        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
          style={{ fontSize: "20px" }}
        >
          <ul className="navbar-nav  ml-auto">
            <li className="nav-item active" onClick={() => this.changeTab(0)}>
              <Link className="nav-link" to="/project" id="project">
                <span
                  style={{ color: this.state.curr_tab === 0 ? "yellow" : null }}
                >
                  Project
                </span>{" "}
                <span className="sr-only">(current)</span>
              </Link>
            </li>
            <li className="nav-item active" onClick={() => this.changeTab(1)}>
              <Link
                style={{ color: this.state.curr_tab === 1 ? "yellow" : null }}
                className="nav-link"
                to="/agency"
              >
                Agency
              </Link>
            </li>
            <li className="nav-item active" onClick={() => this.changeTab(2)}>
              <Link
                style={{ color: this.state.curr_tab === 2 ? "yellow" : null }}
                className="nav-link"
                to="/legislation"
              >
                Legislation
              </Link>
            </li>
            <li className="nav-item active" onClick={() => this.changeTab(3)}>
              <Link
                style={{ color: this.state.curr_tab === 3 ? "yellow" : null }}
                className="nav-link"
                to="/organization"
              >
                Organization
              </Link>
            </li>
            {isAdmin ? (
              <li className="nav-item active" onClick={() => this.changeTab(4)}>
                <Link
                  style={{ color: this.state.curr_tab === 4 ? "yellow" : null }}
                  className="nav-link"
                  to="/admin"
                >
                  Admin
                </Link>
              </li>
            ) : (
              ""
            )}
          </ul>
          <ul className="navbar-nav">{this.renderContent()}</ul>
          <script />
        </div>
      </nav>
    );
  }
}

export default withRouter(Header);
